module.exports = __webpack_public_path__ + "static/media/digitizer.45d6625b.svg";